<template>
  <v-dialog fullscreen persistent scrollable>
    <template v-slot:activator="{ props: activatorProps }">
      <v-list-item link v-bind="activatorProps">
        <template v-slot:append>
          <v-icon :icon="['fas', 'print']" />
        </template>
        ПЕЧАТЬ
      </v-list-item>
    </template>

    <template v-slot:default="{ isActive }">
      <v-card>
        <template v-slot:prepend>
          <v-img class="mb-3" id="g_logo" src="https://media.scgrdn.pro/global/logotypes/guardian/guardian.png" width="200" />
        </template>

        <template v-slot:title>
          <p>ГРАФИК ПРОВЕДЕНИЯ РАБОТ</p>
        </template>
        <template v-slot:subtitle>
          <p>ИНСТРУМЕНТ ПЕЧАТИ</p>
        </template>
        <template v-slot:append>
          <v-btn
              v-if="full_contract"
              flat
              color="light-green-lighten-4"
              class="mr-2"
              variant="flat"
              :icon="true"
              :disabled="printing"
              v-on:click="print_table()"
          >
            <v-icon :icon="['fas', 'print']" />
          </v-btn>
          <v-btn
              flat
              color="deep-orange"
              variant="tonal"
              :icon="true"
              :disabled="printing"
              @click="isActive.value = false"
          >
            <v-icon :icon="['fas', 'xmark']" />
          </v-btn>
        </template>
        <template v-slot:text>
          <v-select v-model="contract" :items="contracts" item-title="name" item-value="guid" :disabled="printing"/>
          <v-sheet class="d-flex justify-space-between align-center">
            <v-text-field v-model="humans.director" label="Производственный директор" :disabled="printing"/>
            <v-text-field v-model="humans.signer" label="Согласовал" :disabled="printing"/>
          </v-sheet>

          <v-sheet v-if="contract">
            <template v-for="month of selected_data" :key="month">
              <table v-if="month.objects.length > 0" class="plan_graphs mt-3" :id="`plan_graph_${month.index}`">
                <thead>
                  <tr>
                    <th class="text-left font-weight-bold" :colspan="month.days.length + 1" style="border: 1px solid #5b5b5b;">
                      {{ month.name }}
                    </th>
                  </tr>
                  <tr>
                    <th class="font-weight-bold" style="position: relative; font-size: 12px; margin: 5px; border: 1px solid #5b5b5b;">
                      <p style="position: absolute; top: 0; right: 0;">Даты</p>
                      <p style="position: absolute; bottom: 0; left: 0;">Физ.объект</p>
                    </th>
                    <th style="border: 1px solid #5b5b5b; font-size: 12px" class="text-center pa-1" v-for="day of month.days" :key="day">
                      {{ moment(day.date).format('DD.MM') }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                      v-for="object in month.objects"
                      :key="object"
                  >
                    <td style="border: 1px solid #5b5b5b; font-size: 12px;" class="font-weight-bold ml-1">
                      {{ object.object.name }}
                    </td>
                    <td style="border: 1px solid #5b5b5b; text-align: center;" :class="{ 'is_weekend' : check_week_day(day.weekday) }" v-for="day of month.days" :key="day">
                      <p class="doc-text" v-for="doc in get_docs(object, day)" :key="doc" style="font-family: Arial, sans-serif">
                        <v-sheet color="transparent" class="d-flex justify-center align-center">
                          {{ get_type_icon(doc.type) }}
                          <span>#{{ doc.zn }}</span>
                        </v-sheet>
                      </p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </template>
          </v-sheet>
        </template>
      </v-card>
    </template>
  </v-dialog>


</template>

<script>
import { Documents } from "@/store/zn_planner/Documents";
import { Allerts } from "@/store/global/Allerts";
import { TokenGUIDStore } from "@/store/global/SessionStore";
import { CurrentYearCalendar } from "@/store/zn_planner/CalendarOfYear";
import moment from "moment";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";

export default {
  name: 'ZN_Printer',
  beforeMount: async function () {
    await this.get_available_contracts()
  },
  data() {
    return {
      from_top: 0,
      printing: false,
      contracts: null,
      contract: null,
      months: [],
      pdf: null,
      humans: {
        director: this.$config.DIRECTOR,
        signer: null
      }
    }
  },
  methods: {
    print_table: async function () {
      this.printing = true
      this.pdf = new jsPDF({
        orientation: 'l',
        unit: 'mm',
        format: [297, 210]
      })

      await this.print_title()
      await this.print_graphs()
      await this.print_document()
    },
    print_title: async function() {
      this.from_top = 10
      let height = 12
      let width = height*3.56106870229
      let image = new Image()
      image.src = require('@/assets/logotypes/executors/Itc_black.png')
      this.pdf.addImage(image, 'png', 10, 4, width, height)


      // Договор ОТ:
      this.pdf.setFontSize(8)
      this.pdf.setFont('DinCyRg')
      let num = this.full_contract.number ? this.full_contract.number : '________________'
      let date = this.full_contract.date ? moment(this.full_contract.date).format('DD.MM.YYYY') : '___.___._______г.'
      let text = `по договору №${num} от ${date}`
      this.pdf.text(text, 297-10, 4, 'right')

      // Печатаем титульный текст
      let tmp = []
      let array = [
        'ГРАФИК ОКАЗАНИЯ УСЛУГ',
        `на период: с ${moment(this.calendar.special.dates.start).format('DD.MM.YYYY')} по ${moment(this.calendar.special.dates.end).format('DD.MM.YYYY')}`,
        `на объекте ${this.full_contract.name}`
      ]
      for (let i = 0; i < array.length; i++) {
        if (array[i] !== '') {
          if (!(array[i].length > 70)) {
            tmp.push(array[i])
          } else {
            let strokes = this.pdf.splitTextToSize(array[i], 200)
            tmp.push(strokes)
          }
        }
      }
      array = tmp
      for (let i = 0; i < array.length; i++) {
        this.pdf.setFontSize(12)
        this.pdf.setFont('DinCyBd')
        this.pdf.text(array[i], 297/2, this.from_top, 'center')
        if (i < array.length - 1) {
          this.from_top += 4
        } else {
          this.from_top += 10
        }
      }
      // Печатаем подписантов
      let y = this.from_top - 3
      this.pdf.setFontSize(10)
      this.pdf.setFont('DinCyRg')
      this.pdf.text(`Производственный директор: ______________/${this.humans.director?this.humans.director:"_____________"}`, 10,     y, 'left')
      this.pdf.text(`_____________/${this.humans.signer?this.humans.signer:"_____________"}`,                               297-10, y, 'right')
    },
    print_graphs: async function() {
      let graphs = document.getElementsByClassName('plan_graphs')
      for (let graph of graphs) {
        console.log(this.from_top)
        await html2canvas(graph, {
          dpi: 3000,
          scale: 2
        }).then(canvas => {
          let img = canvas.toDataURL("image/png", 2)
          let width = 297-20
          let height = width * (canvas.height / canvas.width)

          if (height > 210 - this.from_top) {
            this.pdf.addPage()
            this.from_top = 10
          }
          this.pdf.addImage(img, 'png', 10, this.from_top, width, height)
          this.from_top += (height + 2)
        })
      }
    },
    print_document: async function () {
      await this.pdf.save('report.pdf')
      this.printing = false
    },
    check_week_day: function (weekday) {
      switch (weekday) {
        case 6:
        case 7:
          return true
        default:
          return false
      }
    },
    get_type_icon: function (type) {
      switch (type.name) {
        case 'Техническое обслуживание':
          return 'ТО'
        case 'Испытания':
          return 'И'
        default:
          return '?'
      }
    },
    get_docs: function (object, day) {
      return object.documents.filter(d => d.date === day.date)
    },
    get_available_contracts: async function () {
      let url = `${this.$config.SSL}://${this.$config.ONEADDRESS}/${this.$config.BASE}/${this.$config.ONETEST}/AvailableContracts`
      let raw = {
        district: this.district,
        quarter: this.quarter
      }
      let props = {
        method: 'POST',
        withCredentials: true,
        headers: {
          "Authorization": "Bearer " + this.session_token
        },
        body: JSON.stringify(raw)
      }
      await fetch(url, props)
          .then(async response => {
            if (response.ok) {
              return await response.json()
            } else {
              throw `Ошибка получения списка контрактов!`
            }
          })
          .then(result => {
            this.contracts = result
          }).catch(err => {
            Allerts().warn('ОШИБКА!', `${err}`, '#ff4422', 'triangle-exclamation')
            console.error(err)
          })
    },
  },
  computed: {
    full_contract() {
      return this.contracts.find(c => c.guid === this.contract)
    },
    moment() {
      return moment
    },
    days() {
      let days = []
      this.calendar.months.forEach(month => {
        month.days.forEach(day => {
          days.push({
            date: day.date,
            weekday: day.weekday
          })
        })
      })
      return days
    },

    selected_data() {
      let months = []
      months = this.calendar.months.map((month, index) => {
        return {
          name: month.name,
          index: index,
          days: month.days.map(day => { return day }),
          objects: get_month_objects(month, this.contract, this.calendar)
        }
      })
      // Генерируем список уникальных Физ.Объектов
      function get_month_objects(month_o, contract, calendar) {
        let objs = []
        calendar.months.forEach(month => {
          month.days.forEach(day => {
            day.documents.forEach(doc => {
              if (doc.contract === contract && month === month_o) {
                objs.push(doc.object)
              }
            })
          })
        })
        objs = Array.from(new Set(objs.map(JSON.stringify))).map(JSON.parse);
        let objects = []
        objs.forEach(obj => {
          objects.push({
            object: obj,
            documents: (() => {
              let docs = []
              calendar.months.forEach(month => {
                month.days.forEach(day => {
                  day.documents.forEach(doc => {
                    if (doc.contract === contract && month === month_o && doc.object.guid === obj.guid) {
                      docs.push({
                        date: day.date,
                        weekday: day.weekday,
                        zn: doc.number,
                        type: doc.type
                      })
                    }
                  })
                })
              })
              return docs
            })()
          })
        })
        return objects
      }
      return months
    },
    documents: {
      get() {
        return Documents().get()
      },
      set(value) {
        Documents().set(value)
      }
    },
    calendar: {
      get() {
        return CurrentYearCalendar().get()
      },
      set(value) {
        CurrentYearCalendar().set(value)
      }
    },
    quarter() {
      return parseInt(this.$route.params.quarter)
    },
    district() {
      return this.$route.params.guid
    },
    session_token() {
      return TokenGUIDStore().get()
    }
  }
}

</script>

<style scoped>
.text-to {
  color: #8b3f00;
}

.text-isp {
  color: #85d91f;
}

.unknown {
  color: #000000;
}
.doc-text {
  font-size: 10px;
}

.is_weekend {
  background: #efefef;
  background-image: url("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAxNi4wLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+DQo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4Ig0KCSB3aWR0aD0iNHB4IiBoZWlnaHQ9IjRweCIgdmlld0JveD0iMCAwIDQgNCIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgNCA0IiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxsaW5lIGZpbGw9Im5vbmUiIHN0cm9rZT0iI0FCQUJBQiIgc3Ryb2tlLXdpZHRoPSIwLjUiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgeDE9IjAiIHkxPSIwIiB4Mj0iNCIgeTI9IjQiLz4NCjwvc3ZnPg0K");
  background-repeat: repeat;
  background-position: 0 0;
}
</style>
